import script from "./AppSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=44e59fe9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44e59fe9"]])

export default __exports__